import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, putInCanvas, toImage } from "../util.js"

rendererResolvers.push(
	({ item }) => {
		if (item.fab_type == null)
			return

		return {
			discriminator: `${item.id}_${item.fab_type}`,
			async render() {
				const canvas = createCanvas(0, 0)
				const ctx = canvas.getContext("2d")

				const imgFab = await getImage(item.buildInfo[0].image)
				const imgIcon = await getImage(`fab_t_${item.fab_type.toLowerCase()}`)

				putInCanvas(canvas, ctx, imgFab)

				ctx.drawImage(imgIcon, 61, 4) // fab icon offset

				return [{ image: await toImage(canvas) }]
			}
		}
	}
)
